import App from './App';

export { App };



// WEBPACK FOOTER //
// ./src/preference/containers/index.js